<div class="hero-section">
<div class="banner" *ngIf="loanPurpose === 'CC'">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-6 ms-auto">
                <div class="card Pre-Qualify">
                    <h3>Credit Cards for <br> Every Lifestyle.</h3>
                    <h5>See your card offers with <br> no impact to your credit </h5>
                    <div class="d-flex align-items-center justify-content-between mt-3 flex-wrap flex-md-nowrap gap-2">
                        <button class="btn blue-btn" (click)="gotoCXUrl()">See if I Pre-Qualify</button>
                        <button class="btn text-white white-bold work-link" (click)="openFAQModel()">How it Works</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="business-banner" *ngIf="loanPurpose === 'BCC'|| loanPurpose === 'BCC_CHARGE'">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-6 ms-auto">
                <div class="card Pre-Qualify">
                    <h3>Credit Cards for <br> All your Business <br> Needs.</h3>
                    <h5>Find the best card <br> for your business.</h5>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<div class="tabs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 px-0">
                <ul ngbNav #cardsNav="ngbNav" class="nav-tabs" [(activeId)]="activeNavTab">
                    <li class="nav-item" [ngbNavItem]="1"  *ngIf="personalCC.length > 0" (click)="setLoanPurpose('CC')">
                        <button ngbNavLink>Personal Cards</button>

                        <ng-template ngbNavContent>
                            <ng-container [ngTemplateOutlet]="cardListTemplate"
                                          [ngTemplateOutletContext]="{cardList: personalCC}"></ng-container>
                        </ng-template>
                    </li>
                    <li class="nav-item" [ngbNavItem]="2"  *ngIf="allBusinessCC.length > 0 || allBusinessCCCharge.length > 0" (click)="selectBusinessCardType()">
                        <button ngbNavLink>Business Cards</button>

                        <ng-template ngbNavContent>
                            <ng-container [ngTemplateOutlet]="cardListTemplate"
                                          [ngTemplateOutletContext]="{cardList: businessCC}"></ng-container>
                        </ng-template>
                    </li>
                </ul>

                <div class="tab-content" id="myTabContent" [ngbNavOutlet]="cardsNav"></div>
            </div>
        </div>
    </div>
</div>


<div class="pre-footer py-md-4 py-sm-4 py-2" *ngIf="loanPurpose === 'CC'">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/fico-icon.svg" alt="">
                    </div>
                    <h6>No impact to your credit score.</h6>
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/card-icon.svg" alt="">
                    </div>
                    <h6>Find a card that fits your needs.</h6>
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/timer-icon.svg" alt="Takes less than a minute.">
                    </div>
                    <h6>Takes less than a minute.</h6>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pre-footer py-md-4 py-sm-4 py-3" *ngIf="loanPurpose !== 'CC'">
    <div class="container">
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/Expense-icon.svg" alt="">
                    </div>
                    <h6>Expense Management Tools</h6>
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/cost-employe-icon.svg" alt="">
                    </div>
                    <h6>No Cost Employee Cards</h6>
                </div>
            </div>

            <div class="col-md-4 col-sm-6">
                <div class="pre-footer-box">
                    <div class="img-wrapper">
                        <img src="/assets/image/fraud-monitoring-Icon.svg" alt="Takes less than a minute.">
                    </div>
                    <h6>Fraud Monitoring and Alerts</h6>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-btn py-md-4 py-3">
    <div class="container">
        <div class="row" *ngIf="loanPurpose === 'CC'">
            <div class="col-12">
                <div class="text-center">
                   <!-- <h4 class="mb-3" (click)="gotoCXUrl()">See if I Pre-Qualify</h4>-->
                    <button class="btn blue-btn" (click)="gotoCXUrl()">Get Started</button>
                </div>
            </div>
        </div>

        <div *ngIf="loanPurpose == 'CC'">
            <hr class="grey-line">
            <p class="footer-text mt-0 mb-0 fw-medium fz"><b class="head-color">USA PATRIOT ACT</b><br>
                IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT<br>
                To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.</p>
            <p class="footer-text mt-0 mb-0 fw-medium fz"><b class="head-color">MILITARY LENDING ACT</b><br>
                Important disclosures about the Military Lending Act will be provided with your card. If you would like information now, please contact us at 1-800-883-0131.
            </p>
        </div>
        <div class="row" *ngIf="showRewardsDisclosure">
            <div class="col-md-12 text-center mt-2" >
                <span><sup>1</sup>Account must be open and in good standing to access rewards.</span><br>
            </div>
        </div>
    </div>
</div>


<ng-template #cardListTemplate let-cardList="cardList">
    <div class="container">
        <div class="row pt-5">
            <div class="skeleton row" *ngIf="cardList.length <= 0">
                <div class="col-md-4 col-sm-6 p-2" *ngFor="let card of skeletonCards">
                    <div class="skeleton-card pt-2 pb-3" >
                        <div class="skeleton-card-image"></div>
                        <div class="skeleton-card-content py-3">
                            <h2></h2>
                            <p></p>
                            <button class="btn"></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-sm-6 p-2" *ngFor="let card of cardList">
                <div class="py-3 card-box d-flex flex-column h-100">
                    <div class="img-wrapper">
                        <img [src]="card.imageUrl" class="card-img-top" alt="Visa Card">
                    </div>
                    <div class="card-content px-2 text-center d-flex flex-column h-100">
                    <h2> {{card.name}} </h2>
                    <div class="card-body d-flex flex-column justify-content-between">
                        <ul class="card-details p-0">
                            <li> {{card.subTitle}} </li>
<!--                            <li> {{card.shortInfo}}</li>-->
                            <!-- Add more details here as needed -->
                        </ul>
                        <div class="text-center">
                            <a [routerLink]="['/card-detail/', loanPurpose, card.id]"
                               [queryParams]= "{merchantId:merchantId}"
                               target="_blank">Learn More</a>
                            <br>
                            <button class="apply-btn btn blue-btn" (click)="gotoCXUrl()" *ngIf="loanPurpose === 'BCC'|| loanPurpose === 'BCC_CHARGE'">Apply Now</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #popupContent let-modal >
    <div class="modal-header p-0">
        <h5 class="modal-title p-3 pb-2 fw-semibold">Let’s find the right card for your business.</h5>
    </div>
    <div class="modal-body p-0">
        <p class="p-3 pb-0 fw-medium">Please select a statement that applies to your business:</p>
        <ul class="list-unstyled business-option-list">
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC_CHARGE')">
                <span class="circle"></span>
                <div>
                    <button class="fw-semibold">My business is a non-profit or a municipality</button> <br>
                    <small>Example: church, fire station, school, etc.</small>
                </div>
            </li>
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC_CHARGE')">
                <span class="circle"></span>
                <button class="fw-semibold">My business has 50+ employees or has annual revenues greater than $7million</button>
            </li>
            <li class="d-flex px-3 py-2" (click)="updateAccountType('BCC')">
                <span class="circle"></span>
                <button class="fw-semibold">None of the statements apply to my business</button>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #faqContent let-modal>
    <div class="modal-header p-0">
        <h5 class="modal-title p-3 pb-2">Frequently Asked Questions</h5>
    </div>
    <div class="modal-body">
        <div class="accordion" id="faq-accordion">
            <div class="card">
                <div class="card-header" id="faq-1">
                    <h5 class="mb-0">
                        <button class="btn btn-link pl-0" data-toggle="collapse" data-target="#collapse-1" aria-expanded="false" aria-controls="collapse-1">
                        What does it mean to be pre-qualified?
                        </button>
                    </h5>
                </div>
                <div id="collapse-1" class="collapse" aria-labelledby="faq-1" data-parent="#faq-accordion">
                    <div class="card-body">
                        Pre-qualification is a way to see personalized credit card offers available to you based on information you provide on the prequalification form, without affecting your credit score. These credit card offers shown are based on your personal and financial information entered and are not a guarantee of approval.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="faq-2">
                    <h5 class="mb-0">
                        <button class="btn btn-link pl-0" data-toggle="collapse" data-target="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                        Will my credit score be affected by checking to see if I’m pre-qualified?

                        </button>
                    </h5>
                </div>
                <div id="collapse-2" class="collapse" aria-labelledby="faq-2" data-parent="#faq-accordion">
                    <div class="card-body">
                        Completing the prequalification form involves a “soft inquiry” from the credit bureau which does not affect your credit score.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="faq-3">
                    <h5 class="mb-0">
                        <button class="btn btn-link pl-0" data-toggle="collapse" data-target="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                        Do pre-qualification offers guarantee a credit card account?
                        </button>
                    </h5>
                </div>
                <div id="collapse-3" class="collapse" aria-labelledby="faq-3" data-parent="#faq-accordion">
                    <div class="card-body">
                        With pre-qualification, we can review your creditworthiness with standard financial information. However, this does not guarantee approval.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="faq-4">
                    <h5 class="mb-0">
                        <button class="btn btn-link pl-0" data-toggle="collapse" data-target="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                        What happens after I see pre-qualified credit card offers?
                        </button>
                    </h5>
                </div>
                <div id="collapse-4" class="collapse" aria-labelledby="faq-4" data-parent="#faq-accordion">
                    <div class="card-body">
                        After viewing the offers you pre-qualify for, you can choose if you want to apply. You will be able to see rates and card details before applying. When you apply, you will need to share additional financial information which results in a hard inquiry on your credit.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header" id="faq-5">
                    <h5 class="mb-0">
                        <button class="btn btn-link pl-0" data-toggle="collapse" data-target="#collapse-5" aria-expanded="false" aria-controls="collapse-5">
                        What will you do with my personal information such as my Social Security Number?
                        </button>
                    </h5>
                </div>
                <div id="collapse-5" class="collapse" aria-labelledby="faq-5" data-parent="#faq-accordion">
                    <div class="card-body">
                        Your Social Security Number is used for identification purposes during the pre-qualification process without affecting your credit score. We will use the information you provide in accordance with our privacy notice.
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>
